import { render, staticRenderFns } from "./OmniCard.vue?vue&type=template&id=402c5cce&"
import script from "./OmniCard.vue?vue&type=script&lang=js&"
export * from "./OmniCard.vue?vue&type=script&lang=js&"
import style0 from "./OmniCard.vue?vue&type=style&index=0&id=402c5cce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports